import clsx from "classnames";
import { Banner } from "@/ui/Banner";
import { useLocale } from "@/hooks/useLocale";
import { Button, Col, Row } from "react-bootstrap";
import Host from "@/ui/Host";
import { placeholders } from "@/data/placeholders";
import ArrowRight from "@/assets/ArrowRight.svg";
import Calendar from "@/assets/Calendar.svg";
import { format } from "date-fns";
import Location from "@/assets/Location.svg";
import Time from "@/assets/Time.svg";
import classes from "./styles.module.scss";
import { events_helper } from "@/helpers/events_helper";
import { DynamicText } from "@/ui/DynamicText";
import { useLink } from "@/hooks/useLink";

export const EventPageBannerSection = ({ className, event }) => {
  const locale = useLocale();
  const link = useLink();
  const isPastEvent = events_helper.isPastEvent(event);

  return (
    <Banner
      image={{ path: `page.event.banner.bg.image`, src: "/assets/banners/default.png" }}
      className={clsx(className, classes.banner)}
      title={<h1 className="h2">{event[`title_${locale}`]}</h1>}
      backlink={{ url: link("events"), label: <DynamicText path={`events.link.back.${locale}`} /> }}
    >
      <Row>
        <Col xs={12} xl={6}>
          <Row>
            <Col xs={12} className={clsx(classes.banner__details, "mb-2 small")}>
              <dl className="flex-shrink-0">
                <dt>
                  <Time />
                </dt>
                <dd>{event.time}</dd>
              </dl>
              <dl className="flex-shrink-0">
                <dt>
                  <Calendar />
                </dt>
                <dd>{format(new Date(event.date), "MMM dd yyyy")}</dd>
              </dl>
              <dl>
                <dt>
                  <Location />
                </dt>
                <dd>{event.location}</dd>
              </dl>
            </Col>
            <Col xs={12} className="mb-5" dangerouslySetInnerHTML={{ __html: event[`description_${locale}`] }} />
            {!isPastEvent ? (
              <>
                <Col xs={12} md={8}>
                  {event.host.map((i, k) => (
                    <Host className="mb-4" key={k} item={i} />
                  ))}
                </Col>
                <Col xs={12} md={4} className="d-flex justify-content-end align-items-start">
                  <Button variant="primary" href="#signup" size="lg" tabIndex={undefined}>
                    <span className="me-3">{placeholders[`page.event.button.signup.${locale}`]}</span>
                    <ArrowRight width="14" height="12" />
                  </Button>
                </Col>
              </>
            ) : (
              <Col xs={12} className="d-flex justify-content-end">
                <div>
                  <DynamicText path={`page.event.hasPast.message.${locale}`} className="small mb-2" tag="p" />
                  <Button variant="primary" href={link("events")} tabIndex={undefined}>
                    <span className="me-3">{placeholders[`page.event.hasPast.button.${locale}`]}</span>
                    <ArrowRight width="14" height="12" />
                  </Button>
                </div>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </Banner>
  );
};
